module.exports = __webpack_public_path__ + "static/media/user-default-image.7c5803a4.png";